export const getDisplayName = (name = "ABC") => {
  const value = name.toLowerCase();
  if (
    value.includes("class") ||
    value.includes("coach") ||
    value.includes("institute") ||
    value.includes("academy") ||
    value.includes("centre") ||
    value.includes("center") ||
    value.includes("tution") ||
    value.includes("tutor")
  ) {
    return name;
  } else {
    return `${name} Classes`;
  }
};
export const initials = (coachingName = "") => {
  if (coachingName) {
    return coachingName
      .split(" ")
      .map((item) => item[0] && item[0].toUpperCase())
      .join("");
  } else {
    return "ABC";
  }
};
